/**
 * The K60 mesh as a quiet sign for an empty state (UX rulings 2/6, CI §3):
 * three slim parallelograms at −22° from vertical, in the grey of the mark
 * and of the hairline — never the red pair, which belongs to the chrome
 * (CI §2.1). Sheared about the centre like `K60Mesh`, for the same reason.
 * Not `K60Mesh` itself: that one carries the brand red.
 */
export function MeshMark({ size = 40 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" aria-hidden="true" focusable="false">
      <g transform="skewX(-22)" style={{ transformOrigin: "center" }}>
        <rect x="10" y="7" width="5" height="26" rx="1" fill="var(--rule-strong)" />
        <rect x="18" y="7" width="5" height="26" rx="1" fill="var(--masche)" />
        <rect x="26" y="15" width="5" height="18" rx="1" fill="var(--rule-strong)" />
      </g>
    </svg>
  );
}
